import { Component, OnInit } from '@angular/core';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuizData } from '../QuizData';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// import { userInfo } from 'os';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';
import { NgbdModalContent } from '../../alert-component';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-demographyquiz',
  templateUrl: './demographyquiz.component.html',
  styleUrls: ['./demographyquiz.component.css']
})
export class DemographyquizComponent{
  demoquizForm : FormGroup;
  submitted: boolean = false;
  riskScore: string = "";
  // userId;
  
  successMessage: string;
  failedMessage: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private  _bkoffService: BackOffServiceService,
    private formBuilder : FormBuilder,
    private modalService: NgbModal,
    private cookie : CookieService,

    ) {
      Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
      (Parse as any).serverURL = environment.serverURL;
    }

  ngOnInit() {
    let regexPatterns = {
      // this can be improved
      zip: "^[0-9]{5}$",
   };
    this.demoquizForm  =  this.formBuilder.group({
  
      enrolled: ['', Validators.required],
      zip: ['', [Validators.required, Validators.pattern(regexPatterns.zip)]],
      education: ['', Validators.required],
      diabetes: ['', Validators.required],
      prediabetes: ['', Validators.required],
      payer: ['', Validators.required],
       
    });

    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0)
    });

    // this.route.paramMap.subscribe(params => {
    //   this.userId = params.get('userId');
    // });
    // console.log(this.userId);
  }

  get fmBuilder() { return this.demoquizForm.controls; }  

  reset(){
    this.demoquizForm.reset({PersonalData: new QuizData()});
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.demoquizForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.demoquizForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  btnclick(){
    
    const result: QuizData = Object.assign({}, this.demoquizForm.value);
    let fromResult = Object.assign({}, result);

    this.submitted = true;

    console.log("about to check form validation");
    // stop here if form is invalid
    if (this.demoquizForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }

     const signUpData = this.demoquizForm;
     
     
      var userInfo = new QuizData()

      userInfo.zip = Number(signUpData.get(['zip']).value)
      userInfo.enrolled = Number(signUpData.get(['enrolled']).value)
      userInfo.education = Number(signUpData.get(['education']).value)
      userInfo.payer = Number(signUpData.get(['payer']).value)
      userInfo.diabetes = Number(signUpData.get(['diabetes']).value)
      userInfo.prediabetes = Number(signUpData.get(['prediabetes']).value)

      console.log("motiv" + userInfo.motiv)
      console.log("why" + userInfo.whyChange)
      console.log("habits" + userInfo.habit)
      console.log("what happen" + userInfo.whatHappen)

      console.log(userInfo.score)

      this._bkoffService.setDemoQuizData(userInfo);

    console.log("btnclick registered")

    this.router.navigateByUrl('/quiz3');
  };

}
